import React, { useEffect } from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter } from '@heroui/modal';
import { Button } from '@heroui/button';
import dayjs from 'dayjs';
import { entityEventsToSlides } from '@/shared/clientFunctions';
import { Source } from '@/shared/types';
export interface EventsReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  question: string;
  extractionJob: any;
  setApplyCardOpen: (open: boolean) => void;
  createEventsFromEntityEvents: (jobId: string, events: any[], enriching: boolean, timelineIdIn?: string) => void;
  getEventsFromEntityService: (action: string, timelineId: string | null, caseId: string, answerItemText: string, sources: Source[], epochTimeSecs: number, jobId: string | null, cancelPolling: boolean) => Promise<void>;
}
export default function EventsReviewModal({
  isOpen,
  onClose,
  question,
  extractionJob,
  setApplyCardOpen,
  createEventsFromEntityEvents,
  getEventsFromEntityService
}: EventsReviewModalProps) {
  useEffect(() => {
    if (extractionJob?.result?.events) {
      const slides = entityEventsToSlides(extractionJob.result.events, [], []);
    }
  }); //, [extractionJob]);

  return <Modal isOpen={isOpen} onClose={() => setApplyCardOpen(false)} hideCloseButton={true} classNames={{
    wrapper: 'bg-black/50 opacity-100 z-[999999]',
    base: 'bg-gray-800 h-[calc(50vh)] w-[800px] sm:max-w-[98vw] max-w-[90vw] rounded-md opacity-100 overflow-hidden',
    backdrop: 'bg-black/50'
  }} data-sentry-element="Modal" data-sentry-component="EventsReviewModal" data-sentry-source-file="events-review-modal.tsx">
    <ModalContent className="max-h-[calc(90vh-160px)]" data-sentry-element="ModalContent" data-sentry-source-file="events-review-modal.tsx">
      <ModalHeader className="box-border flex flex-row justify-between gap-0 items-start bg-gray-800 text-white/80 font-light p-2 pt-1
        overflow-y-auto custom-scrollbar2 mt-2" data-sentry-element="ModalHeader" data-sentry-source-file="events-review-modal.tsx">
        <div className="box-border bg-gray-900 text-white/80 font-light rounded-sm p-2 py-1">
          {question}
        </div>
      </ModalHeader>
      <ModalBody className="flex flex-col gap-1 bg-gray-700 text-white/80 font-light p-1 pt-0 m-0
          overflow-y-auto custom-scrollbar2 max-h-[calc(100%-120px)]" data-sentry-element="ModalBody" data-sentry-source-file="events-review-modal.tsx">
        <div className="box-border flex flex-row justify-between items-center bg-gray-700 text-white/80 font-semibold py-1 mr-2 rounded-sm">
          <div className="box-border flex flex-row justify-start items-center w-[5%] bg-gray-800 text-left text-white/80 font-semibold rounded-sm h-full pl-2 p-1 mr-1">#</div>
          <div className="box-border flex flex-row justify-start items-center w-[40%] bg-gray-800 text-left text-white/80 font-semibold rounded-sm h-full pl-2 p-1 mr-1">Title</div>
          <div className="box-border flex flex-row justify-start items-center w-[40%] bg-gray-800 text-left text-white/80 font-semibold rounded-sm h-full pl-2 p-1 mr-1">Description</div>
          <div className="box-border flex flex-row justify-start items-center w-[15%] bg-gray-800 text-left text-white/80 font-semibold rounded-sm h-full pl-2 p-1">Date/Time</div>
        </div>
        <div className="flex flex-col gap-2 bg-gray-700 text-white/80 font-light p-0 m-0
          overflow-y-auto custom-scrollbar2 max-h-[calc(100%-20px)] rounded-sm">
          {extractionJob?.result?.events?.map((event: any, index: number) => {
            const eventDate = dayjs(event.eventDate);
            const eventDateString = eventDate.format('MM/DD/YYYY');
            const eventTimeString = eventDate.format('hh:mm:ss A');
            return <div key={index} className="box-border flex flex-row justify-between items-center gap-1 bg-gray-700 text-white/80 font-light rounded-sm">
                <div className="box-border bg-gray-800 text-white/80 font-light rounded-sm h-full w-[5%] p-2">
                  {index + 1}
                </div>
                <div className="box-border bg-gray-800 text-white/80 font-light rounded-sm h-full w-[40%] p-2">
                  {event.eventSummary}
                </div>
                <div className="box-border bg-gray-800 text-white/80 font-light rounded-sm h-full w-[40%] p-2">
                  {(event.rawTexts || []).join('\n')}
                </div>
                <div className="box-border bg-gray-800 text-white/80 font-light rounded-sm h-full w-[15%] p-2">
                  <div className="box-border text-xs">{eventDateString}</div>
                  <div className="box-border text-xs">{eventTimeString}</div>
                </div>
              </div>;
          })}
        </div>
      </ModalBody>
      <ModalFooter className="flex flex-row justify-between items-center bg-gray-800 text-white/80 font-light p-2 m-0
          min-h-[50px] max-h-[50px] overflow-hidden" data-sentry-element="ModalFooter" data-sentry-source-file="events-review-modal.tsx">
        <Button size="sm" className="flex flex-row justify-center items-center gap-1 bg-red-700 text-white/80 hover:text-white font-light hover:bg-red-800 cursor-pointer" onPress={() => {
          setApplyCardOpen(false);
          getEventsFromEntityService('DELETE_JOB', '', '', '', [], 0, extractionJob?.jobId, true);
          onClose();
        }} data-sentry-element="Button" data-sentry-source-file="events-review-modal.tsx">
          <div className="text-sm">{`Delete`}</div>
        </Button>
        <div className="flex flex-row justify-center items-center gap-1">
          <Button size="sm" className="flex flex-row justify-center items-center gap-1 bg-blue-700 text-white/80 hover:text-white font-light hover:bg-brand-blue-light cursor-pointer" onPress={() => {
            setApplyCardOpen(false);
            createEventsFromEntityEvents(extractionJob?.jobId, extractionJob?.result?.events || [], false, undefined);
            onClose();
          }} data-sentry-element="Button" data-sentry-source-file="events-review-modal.tsx">
            <div className="text-sm">Create Events</div>
          </Button>
          <Button size="sm" className="flex flex-row justify-center items-center gap-1 bg-gray-600 text-white/80 hover:text-white font-light hover:bg-gray-700 cursor-pointer" onPress={() => {
            setApplyCardOpen(false);
            onClose();
          }} data-sentry-element="Button" data-sentry-source-file="events-review-modal.tsx">
            <div className="text-sm">{`Cancel`}</div>
          </Button>
        </div>
      </ModalFooter>
    </ModalContent>
    </Modal>;
}